import React, { useContext } from "react";
import PropTypes from "prop-types";
import { Box } from "@mui/material";
import assignmentPic from "../../assets/images/course_pic.png";
import {
  CourseCard,
  CourseCardSummary,
  CourseCardExpansionPanel
} from "../../components/CourseCard";
import LearningPathListItemButtons from "./LearningPathListItemButtons";
import { courseTypes } from "../../constants";
import ExpandedAssignmentsContext from "../../context/ExpandedAssignmentsContext";

const LearningPathListItem = ({
  assignment,
  index,
  isStarted,
  startCourseClick,
  resumeCourseClick,
  changeEnrollmentClick,
  onAddToCalendarClick,
  reserveTimeClick
}) => {
  const {
    isAssignmentExpanded,
    alwaysShouldBeExpanded,
    onExpandCourseCard,
    getExpansionPanelItems
  } = useContext(ExpandedAssignmentsContext);

  const isEnrolledIlt =
    assignment &&
    assignment.courseType === courseTypes.ilt &&
    assignment.enrolledTrainingObjectId;
  const iltVersion = isEnrolledIlt
    ? assignment.versions.length > 0
      ? assignment.versions.find(
          version => version.id == assignment.enrolledTrainingObjectId
        )
      : assignment.enrolledTrainingObject
    : null;

  const isExpanded =
    isAssignmentExpanded(assignment) || alwaysShouldBeExpanded(assignment);

  return (
    <Box
      key={index}
      display="flex"
      flexDirection="column"
      width="100%"
      mb={3.5}
      data-qa="learning-path-list-item"
    >
      <CourseCard
        status={assignment.status}
        failedStatus={assignment.failedStatus}
        postScore={assignment.postScore}
        passingPostScore={assignment.passingPostScore}
        dueDate={assignment.dueDate}
        scheduleDate={assignment.scheduleDate}
        scheduleTime={assignment.scheduleTime}
        passScore={assignment.passingPostScore}
        activitiesSummary={
          assignment.totalActivities > 0 &&
          assignment.enrolledCtoaId && (
            <CourseCardSummary
              expanded={isExpanded}
              onActivitiesExpandedChange={() =>
                onExpandCourseCard(!isExpanded, assignment)
              }
              totalActivities={assignment.totalActivities}
              numActivitiesCompleted={assignment.numActivitiesCompleted}
              showProgress={assignment.courseType !== courseTypes.policy}
            />
          )
        }
        buttons={
          <LearningPathListItemButtons
            assignment={assignment}
            isStarted={isStarted}
            startCourseClick={startCourseClick}
            resumeCourseClick={resumeCourseClick}
            onAddToCalendarClick={onAddToCalendarClick}
            changeEnrollmentClick={changeEnrollmentClick}
            reserveTimeClick={reserveTimeClick}
          />
        }
        expansionPanel={
          <CourseCardExpansionPanel
            items={getExpansionPanelItems(assignment)}
            expanded={isExpanded}
            passingPostScore={assignment.passingPostScore}
            description={assignment.content}
            assignmentRequirements={assignment.requirements}
            iltInfo={assignment.iltInfo}
            assignmentType={assignment.typeName}
          />
        }
        title={assignment.title}
        courseType={assignment.courseType}
        typeName={assignment.typeName}
        imageSrc={assignment.courseImage || assignmentPic}
        flags={assignment.flags}
        courseDescription={assignment.content}
        assignmentType={assignment.assignmentType}
        passFail={assignment.passFail}
        absent={assignment.absent}
        scheduledDate={assignment.scheduledDate}
        scheduledTime={assignment.scheduledTime}
        endDate={iltVersion ? iltVersion.endDate : null}
        endTime={iltVersion ? iltVersion.endTime : null}
        number={assignment.number}
        manualName={assignment.manualName}
      />
    </Box>
  );
};

export default LearningPathListItem;

LearningPathListItem.propTypes = {
  assignment: PropTypes.any,
  index: PropTypes.number,
  isStarted: PropTypes.bool,
  startCourseClick: PropTypes.func,
  resumeCourseClick: PropTypes.func,
  changeEnrollmentClick: PropTypes.func,
  onAddToCalendarClick: PropTypes.func
};
